import { FC } from "react";
import { ModalFooter } from "../../../lib/src/components/layout/ModalProvider";
import { faKey } from "@fortawesome/free-solid-svg-icons";
import { useApiClient } from "../../../lib/src/api";
import { config } from "../config";
import { useRefresh } from "../../../lib/src/components/RefreshController";
import { Customer } from "@hostingbv/lib/src/api/common/models/Customer";
import { Contact } from "@hostingbv/lib/src/api/common/models/Contact";

export const ResetMFAModal: FC<{ customer: Customer, contact: Contact }> = (props) => {
  const { partnerClient } = useApiClient(config)
  const refresh = useRefresh()
  const reset = async () => {
    await partnerClient.resetCustomerUserMFA(props.customer.id, props.contact.id)
    refresh()
  }

  return <>
    <div>Reset the Multi Factor Authentication for this user?</div>
    <ModalFooter text={"Reset"} icon={faKey} onSubmit={reset} />
  </>
}
